import { render, staticRenderFns } from "./TireComparison.vue?vue&type=template&id=407f3966"
import script from "./TireComparison.vue?vue&type=script&lang=ts"
export * from "./TireComparison.vue?vue&type=script&lang=ts"
import style0 from "./TireComparison.vue?vue&type=style&index=0&id=407f3966&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports